import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DriverService {
    api_url = environment.url;

    constructor(private http: HttpClient) { }

    addDriver(data: any) {
        return this.http.post(`${this.api_url}driver/add`, data);
    }

    updateDriver(data: any, id: number) {
        return this.http.post(`${this.api_url}driver/update/${id}`, data);
    }

    listDriver() {
        return this.http.get(`${this.api_url}driver/list`)
    }
    getId(id: number) {
        return this.http.get(`${this.api_url}driver/show/${id}`)
    }
    getInfo() {
        return this.http.get(`${this.api_url}driver/getCombo`)
    }
    deleteDriver(id: any) {
        return this.http.get(`${this.api_url}driver/delete/${id}`)
    }

    importDrivers(file: File, delimiter?: string, dryRun?: boolean): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);
        if (delimiter) {
            formData.append('delimiter', delimiter);
        }
        if (dryRun !== undefined && dryRun !== null) {
            formData.append('dry_run', dryRun ? '1' : '0');
        }

        return this.http.post<any>(`${this.api_url}driver/import`, formData, {
            reportProgress: true,
            observe: 'events',
        });
    }

    exportDrivers() {
        return this.http.get(`${this.api_url}driver/export`, {
            responseType: 'blob'
        })
    }
}
